import React, { useState, useMemo } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';
import ExpandedKjoeretoyTable from './ExpandedKjoeretoyTable';


const KjoeretoeyTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;


    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('debtorName');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    const [expanded, setExpanded] = useState(null);

    const handleRowClick = (i) => {
        setExpanded(prev => (prev === i ? null : i));
    };

    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
        <thead>
            <tr>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('liensLength', 'num')}>{localeMessages['GH_antallHeftelser']}{t1IndicaterIcon('liensLength')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registrationNumber', 'string')}>{localeMessages['GH_registreringsnummer']}{t1IndicaterIcon('registrationNumber')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('vehicleType', 'string')}>{localeMessages['GH_kjoeretoeyType']}{t1IndicaterIcon('vehicleType')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('brand', 'string')}>{localeMessages['GH_kjoeretoeyMerke']}{t1IndicaterIcon('brand')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('model', 'string')}>{localeMessages['GH_kjoeretoeyModell']}{t1IndicaterIcon('model')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('firstRegistrationDate', 'datetime')}>{localeMessages['GH_foerstegangsregistrert']}{t1IndicaterIcon('firstRegistrationDate')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registrationStatus', 'string')}>{localeMessages['GH_regStatus']}{t1IndicaterIcon('registrationStatus')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('estimatedDealerPrice', 'num')}>{localeMessages['GH_estimertPrisForhandler']}{t1IndicaterIcon('estimatedDealerPrice')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('estimatedPrivateSalePrice', 'num')}>{localeMessages['GH_estimertPrisPrivat']}{t1IndicaterIcon('estimatedPrivateSalePrice')}</th>
            </tr>
        </thead>
      )
    }

    const printRow = (model) => {
        return (
            <>
            <tr key={model.i} onClick={() => handleRowClick(model.j)} style={{ cursor: 'pointer' }}>
                <KredittvurderingTd>
                    {model.liensLength > 0
                        ? expanded === model.j
                            ? (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                                <path d="M7 10l5 5 5-5z" />
                            </svg>
                            )
                            : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                                <path d="M12 7l5 5-5 5" />
                            </svg>
                            )
                        : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="transparent" viewBox="0 0 24 24" width="24" height="24">
                            <path d="M12 7l5 5-5 5" />
                        </svg>
                        )
                    }
                <>&nbsp;({model.liensLength ?? '0'})</>
               </KredittvurderingTd>
               <KredittvurderingTd>{model.info.registrationNumber}</KredittvurderingTd>
               <KredittvurderingTd>{model.info.vehicleType}</KredittvurderingTd>
               <KredittvurderingTd>{model.info.brand}</KredittvurderingTd>
               <KredittvurderingTd>{model.info.model}</KredittvurderingTd>
               <KredittvurderingTd>{model.info.firstRegistrationDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.info.registrationStatus}</KredittvurderingTd>
               <KredittvurderingTd>{model.valuation.estimatedDealerPrice}</KredittvurderingTd>
               <KredittvurderingTd>{model.valuation.estimatedPrivateSalePrice}</KredittvurderingTd>
           </tr>
           {(expanded === model.j) && model.liensLength !== 0 && (
                <>
                    <tr key={model.j + 1000} style={{ backgroundColor: 'white', hover: { opacity: 1 } }} >
                        <td colspan="17" className={expanded ? 'expand-animation' : 'minimize-animation'}>
                            <ExpandedKjoeretoyTable tableData={model.liens} localeMessages={props.localeMessages} />
                        </td>
                    </tr>
                </>
            )}
            </>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Kjøretøy</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default KjoeretoeyTable



